(() => {
  const body = document.body;
  if (!body?.classList.contains('template-collection')) return;

  const initializeLoadMore = (root = document) => {
    root.querySelectorAll('.zf-load-more:not([data-initialized])').forEach((control) => {
      const resultsList = control.closest('results-list');
      const grid = resultsList?.querySelector('.product-grid');
      const button = control.querySelector('.zf-load-more__button');
      const visibleLabel = control.querySelector('[data-zf-visible]');
      const totalLabel = control.querySelector('[data-zf-total]');
      const pageSize = Number(control.dataset.pageSize) || 12;
      const collectionTotal = Number(control.dataset.total) || 0;
      let nextPage = 2;

      if (!grid || !button || !visibleLabel || !totalLabel) return;
      control.dataset.initialized = 'true';

      const update = () => {
        const items = [...grid.querySelectorAll(':scope > .product-grid__item')];
        const visible = items.filter((item) => !item.classList.contains('zf-product-hidden')).length;
        const total = collectionTotal || items.length;

        visibleLabel.textContent = String(visible);
        totalLabel.textContent = String(total);
        control.style.setProperty('--zf-load-progress', `${total ? (visible / total) * 100 : 100}%`);
        button.hidden = visible >= total;
      };

      button.addEventListener('click', async () => {
        let hiddenItems = [...grid.querySelectorAll(':scope > .zf-product-hidden')];

        if (hiddenItems.length === 0 && grid.children.length < collectionTotal) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');

          try {
            const url = new URL(window.location.href);
            url.searchParams.set('page', String(nextPage));
            const response = await fetch(url, { headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error(`Unable to load page ${nextPage}`);

            const html = await response.text();
            const page = new DOMParser().parseFromString(html, 'text/html');
            const newItems = [...page.querySelectorAll('.product-grid > .product-grid__item')];
            newItems.forEach((item) => item.classList.add('zf-product-hidden'));
            grid.append(...newItems);
            nextPage += 1;
            hiddenItems = newItems;
          } catch (error) {
            console.error(error);
          } finally {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        }

        hiddenItems.slice(0, pageSize).forEach((item) => item.classList.remove('zf-product-hidden'));
        update();
      });

      update();
    });
  };

  initializeLoadMore();

  const mainContent = document.querySelector('#MainContent');
  if (mainContent) {
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            initializeLoadMore(node);
          }
        });
      });
    }).observe(mainContent, { childList: true, subtree: true });
  }
})();
